import { useMutation, useQueryClient } from "@tanstack/react-query";
import { startIngestionJobApiDocumentsUploadPost, type IngestionJobStartResponse } from "@noa/api-core";
import { UploadQueryKey } from "../../query-keys";
import { reportError } from "../../typed-client";
import { ApiError } from "../../errors";

export interface StartUploadJobParams {
  files: File[];
  prefix?: string;
  schemaId?: string | null;
  parser?: "PDF" | "PDF_FAST" | "DOCX" | "HTML" | "TXT" | "MARKDOWN" | null;
  withVision?: boolean;
  overwrite?: boolean;
  deleteCollection?: boolean;
  skipIngestion?: boolean;
}

export function useStartUploadJob() {
  const queryClient = useQueryClient();

  return useMutation<IngestionJobStartResponse, ApiError, StartUploadJobParams>({
    mutationFn: async (params) => {
      const { data } = await startIngestionJobApiDocumentsUploadPost({
        body: { files: params.files },
        query: {
          prefix: params.prefix || undefined,
          schema_id: params.schemaId ?? undefined,
          parser: params.parser ?? undefined,
          with_vision: params.withVision,
          overwrite: params.overwrite,
          delete_collection: params.deleteCollection,
          skip_ingestion: params.skipIngestion,
        },
        throwOnError: true,
      });
      return data;
    },
    onError: reportError,
    onSuccess: () => {
      // Invalidate job list to show the new job
      void queryClient.invalidateQueries({ queryKey: UploadQueryKey.list() });
    },
  });
}
